<ng-container *ngIf="(facturasIAService.loading$ | async)">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>

<ng-container>
  <div class="container-fluid mainBody">

    <div class="row mt-2">
      <div class="col-12">
        <h4>Reconocimiento de facturas por medio de la Inteligencia Artificial</h4>
      </div>
    </div>

    <div class="row mt-2 mb-4">
      <div class="col-12">

        <mat-tab-group>
          <mat-tab label="Ficheros sin contabilizar">
            <ng-template matTabContent>
              <div class="container-fluid">
                <div class="row mt-2 mb-2">
                  <div class="col-12" [ngClass]="{'col-sm-6': facturaReconocida != null}">

                    <!-- Tarjeta indicando que no hay facturas sin contabilizar -->
                    <mat-card appearance="outlined" class="mat-elevation-z2"
                      *ngIf="!(facturasIAService.loading$ | async) && (facturasIAService.listaSinContabilizar$ | async).length == 0">
                      <mat-card-title>
                        <h4>No hay facturas sin contabilizar</h4>
                      </mat-card-title>
                    </mat-card>

                    <!-- Tarjeta para mostrar la lista de facturas sin contabilizar -->
                    <mat-card appearance="outlined" class="mat-elevation-z2"
                      *ngIf="(facturasIAService.listaSinContabilizar$ | async).length > 0">
                      <mat-card-title>
                        <h4>
                          Facturas reconocidas sin contabilizar
                        </h4>
                      </mat-card-title>

                      <mat-card-content>
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-12">

                              <div class="table-responsive">
                                <table mat-table [dataSource]="facturasIAService.listaSinContabilizar$ | async" matSort
                                  class="w-100">
                                  <ng-container matColumnDef="acciones">
                                    <th mat-header-cell *matHeaderCellDef class="th-bg"></th>
                                    <td mat-cell *matCellDef="let row">
                                      <ng-container>
                                        <button type="button" mat-icon-button mat-raised-button title="Editar datos"
                                          color="primary" (click)="editar(row)"
                                          [disabled]="(facturasIAService.loading$ | async)">
                                          <mat-icon>create</mat-icon>
                                        </button>
                                      </ng-container>
                                    </td>
                                  </ng-container>

                                  <ng-container matColumnDef="nombreFichero">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre del fichero </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.nombreFichero }} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="type">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.type }} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="cadenaFecha">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.cadenaFecha }} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="error">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Errores detectados </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.error }} </td>
                                  </ng-container>

                                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>
                              </div>

                            </div>
                          </div>
                        </div>

                      </mat-card-content>
                    </mat-card>

                  </div>

                  <div class="col-12 col-sm-6" *ngIf="facturaReconocida != null">

                    <!-- Tarjeta con los datos de la factura reconocida -->
                    <mat-card appearance="outlined">
                      <mat-card-title>
                        <h4>
                          Datos de la factura reconocida
                        </h4>
                      </mat-card-title>

                      <mat-card-content>

                        <div class="container-fluid">

                          <!-- Datos reconocidos de la factura -->
                          <div class="row">
                            <div class="col-12">
                              <div class="table-responsive">
                                <table class="w-100 table table-striped table-bordered">
                                  <tr>
                                    <td>Nombre del fichero:</td>
                                    <td>{{ facturaReconocida.nombreFichero }}</td>
                                  </tr>
                                  <tr>
                                    <td>Tipo:</td>
                                    <td>{{ facturaReconocida.type }}</td>
                                  </tr>
                                  <tr>
                                    <td>Fecha:</td>
                                    <td>{{ facturaReconocida.cadenaFecha }}</td>
                                  </tr>
                                  <tr>
                                    <td>Errores detectados:</td>
                                    <td>{{ facturaReconocida.error }}</td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>

                          <div class="row" *ngIf="contactoReconocido != null && contactoReconocido.id > 0">
                            <div class="col-12">
                              <div class="alert alert-success" role="alert">
                                Emisor reconocido en la factura: <strong
                                  [innerText]="contactoReconocido.companyName"></strong>
                              </div>
                            </div>
                          </div>

                          <!-- Mensaje de información no contenido ::: facturasIAService._ERROR_NO_CONTENT-->
                          <div class="row" *ngIf="facturaReconocida.error == facturasIAService._ERROR_NO_CONTENT">
                            <div class="col-12">
                              <div class="alert alert-warning" role="alert">
                                No se ha reconocido el contenido del archivo. Compruebe que el archivo se ve
                                correctamente y que el contenido no es una imagen, utilizando para ello el botón
                                <strong>VER ARCHIVO</strong>.
                              </div>
                            </div>
                          </div>

                          <!-- Formulario para indicar el proveedor ::: facturasIAService._ERROR_NO_CONTACT -->
                          <div class="row"
                            *ngIf="(facturaReconocida.error == facturasIAService._ERROR_NO_CONTACT) && formContacto !== null">
                            <div class="col-12">

                              <form [formGroup]="formContacto" (onSubmit)="actualizarContacto()">
                                <mat-card appearance="outlined" class="mat-elevation-z2">
                                  <mat-card-content>
                                    <div class="alert alert-danger" role="alert">
                                      El emisor de la factura encontrado no es válido.
                                    </div>

                                    <p>El emisor de la factura no ha sido reconocido. Por favor, seleccione uno de los
                                      contactos reconocidos.</p>

                                    <mat-form-field class="inputWithHelp w-100">
                                      <mat-select name="contactoReconocido" required class="width100"
                                        formControlName="contacto" placeholder="Emisor de la factura"
                                        panelClass="placeholder-mat-select-color-black">
                                        <mat-option *ngFor="let contact of (contactosService.proveedoresDTO$ | async); trackBy: trackByIndex"
                                          [value]="contact">
                                          <span>{{ contact.companyName }}</span>
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                  </mat-card-content>

                                  <mat-card-actions>
                                    <button mat-raised-button type="submit" color="accent"
                                      (click)="actualizarContacto()"
                                      [disabled]="!formContacto.valid || (facturasIAService.loading$ | async)">
                                      ACTUALIZAR
                                    </button>

                                    <button mat-raised-button type="button" color="accent" (click)="nuevoContacto()"
                                      [disabled]="(facturasIAService.loading$ | async)">
                                      NUEVO CONTACTO
                                    </button>
                                  </mat-card-actions>
                                </mat-card>
                              </form>

                            </div>
                          </div>

                          <!-- Formulario para relacionar el tipo de pago con el proveedor ::: facturasIAService._ERROR_NO_RELATION_TYPEPAID -->
                          <div class="row"
                            *ngIf="facturaReconocida.error == facturasIAService._ERROR_NO_RELATION_TYPEPAID">
                            <div class="col-12">

                              <form [formGroup]="formRelacionTipoPago">
                                <mat-card appearance="outlined" class="mat-elevation-z2">
                                  <mat-card-content>
                                    <div class="alert alert-danger" role="alert">
                                      No se ha encontrado la relación entre el tipo de pago y el proveedor.
                                    </div>

                                    <mat-form-field class="inputWithHelp w-100">
                                      <mat-select name="typePaid" required class="width100" formControlName="tipoPago"
                                        placeholder="Tipo de pago" panelClass="placeholder-mat-select-color-black">
                                        <mat-option *ngFor="let method of payMethod; trackBy: trackByIndex" [value]="method">
                                          <span>{{ method }}</span>
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <!-- Efectivo -->
                                    <ng-container *ngIf="formRelacionTipoPago.value.tipoPago === 'Efectivo'">
                                      <mat-form-field class="inputWithoutHelp w-100">
                                        <mat-select name="efectivoId" formControlName="efectivoId"
                                          placeholder="Caja/Efectivo" class="width100"
                                          panelClass="placeholder-mat-select-color-black">
                                          <mat-option *ngFor="let efectivo of efectivoList; trackBy: trackByIndex" [value]="efectivo.uid">
                                            {{efectivo.nombre}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                    </ng-container>

                                    <!-- Tarjeta de crédito -->
                                    <ng-container *ngIf="formRelacionTipoPago.value.tipoPago === 'Tarjeta de crédito'">
                                      <div>
                                        <mat-form-field class="inputWithoutHelp w-100">
                                          <mat-select name="typePayBankAccount" formControlName="typePayBankAccount"
                                            placeholder="Tarjetas de crédito" class="width100"
                                            panelClass="placeholder-mat-select-color-black">
                                            <ng-container *ngFor="let paymentCard of paymentCards; trackBy: trackByIndex">
                                              <mat-option *ngIf="paymentCard.type === 1" [value]="paymentCard.uid">
                                                {{paymentCard.name}} - {{paymentCard.number}}
                                              </mat-option>
                                            </ng-container>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                    </ng-container>

                                    <!-- Tarjeta de débito -->
                                    <ng-container *ngIf="formRelacionTipoPago.value.tipoPago === 'Tarjeta de débito'">
                                      <div>
                                        <mat-form-field class="inputWithoutHelp w-100">
                                          <mat-select name="typePayBankAccount" formControlName="typePayBankAccount"
                                            placeholder="Tarjetas de débito" class="width100"
                                            panelClass="placeholder-mat-select-color-black">
                                            <ng-container *ngFor="let paymentCard of paymentCards; trackBy: trackByIndex">
                                              <mat-option *ngIf="paymentCard.type === 2" [value]="paymentCard.uid">
                                                {{paymentCard.name}} - {{paymentCard.number}}
                                              </mat-option>
                                            </ng-container>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                    </ng-container>

                                  </mat-card-content>

                                  <mat-card-actions>
                                    <button mat-raised-button type="submit" color="accent"
                                      (click)="actualizarTipoPago()"
                                      [disabled]="!formRelacionTipoPago.valid || (facturasIAService.loading$ | async)">
                                      ACTUALIZAR
                                    </button>
                                  </mat-card-actions>
                                </mat-card>
                              </form>

                            </div>
                          </div>

                          <!-- Zona para las acciones relacionadas con la no generación de líneas de factura ::: facturasIAService._ERROR_NO_INVOICE_LINES -->
                          <div class="row" *ngIf="facturaReconocida.error == facturasIAService._ERROR_NO_INVOICE_LINES">
                            <div class="col-12">
                              <div class="alert alert-danger" role="alert">
                                No se han encontrado líneas de factura en la factura reconocida.
                              </div>

                              <button mat-raised-button type="submit" color="accent"
                                (click)="intentarRegenerarFactura()" [disabled]="(facturasIAService.loading$ | async)">
                                INTENTAR REGENERAR
                              </button>
                            </div>
                          </div>
                        </div>

                      </mat-card-content>

                      <mat-card-actions>
                        <button mat-raised-button (click)="cancelar()"
                          [disabled]="(facturasIAService.loading$ | async)">
                          CANCELAR
                        </button>
                        <button mat-raised-button (click)="facturasIAService.verArchivo(facturaReconocida.uidFichero)"
                          [disabled]="(facturasIAService.loading$ | async)">
                          VER ARCHIVO
                        </button>
                        <button mat-raised-button color="warn" (click)="marcarComoEliminada(facturaReconocida)"
                          [disabled]="(facturasIAService.loading$ | async)">
                          ELIMINAR
                        </button>
                      </mat-card-actions>
                    </mat-card>
                  </div>
                </div>
              </div>
            </ng-template>
          </mat-tab>

          <mat-tab label="Ficheros contabilizados">
            <ng-template matTabContent>
              <div class="container-fluid">
                <div class="row mt-2 mb-2">
                  <div class="col-12">

                    <!-- Tarjeta indicando que no hay facturas contabilizadas -->
                    <mat-card appearance="outlined" class="mat-elevation-z2"
                      *ngIf="(facturasIAService.listaContabilizadas$ | async).length == 0">
                      <mat-card-title>
                        <h4>No hay facturas contabilizadas</h4>
                      </mat-card-title>
                    </mat-card>

                    <!-- Tarjeta para mostrar la lista de facturas contabilizadas -->
                    <mat-card appearance="outlined" class="mat-elevation-z2"
                      *ngIf="(facturasIAService.listaContabilizadas$ | async).length > 0">
                      <mat-card-title>
                        <h4>
                          Facturas reconocidas contabilizadas
                        </h4>
                      </mat-card-title>

                      <mat-card-content>
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-12">

                              <div class="table-responsive">
                                <table mat-table [dataSource]="facturasIAService.listaContabilizadas$ | async" matSort
                                  class="w-100">
                                  <ng-container matColumnDef="acciones">
                                    <th mat-header-cell *matHeaderCellDef class="th-bg"></th>
                                    <td mat-cell *matCellDef="let row">
                                      <ng-container>
                                        <button type="button" mat-icon-button mat-raised-button title="Ver datos"
                                          color="primary" [disabled]="(facturasIAService.loading$ | async)">
                                          <mat-icon>visibility</mat-icon>
                                        </button>
                                      </ng-container>
                                    </td>
                                  </ng-container>

                                  <ng-container matColumnDef="nombreFichero">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre del fichero </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.nombreFichero }} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="type">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.type }} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="cadenaFechaProcesado">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha procesada </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.cadenaFechaProcesado }} </td>
                                  </ng-container>

                                  <tr mat-header-row *matHeaderRowDef="displayedColumnsContabilizadas"></tr>
                                  <tr mat-row *matRowDef="let row; columns: displayedColumnsContabilizadas;"></tr>
                                </table>
                              </div>

                            </div>
                          </div>
                        </div>

                      </mat-card-content>
                    </mat-card>
                  </div>
                </div>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>

      </div>
    </div>

  </div>
</ng-container>